export const normalizeColorCode = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  const cleaned = raw.replace(/^#/, '');
  if (!cleaned || !/^[0-9a-fA-F]+$/.test(cleaned)) {
    return '';
  }

  if (cleaned.length === 3) {
    const expanded = cleaned
      .split('')
      .map((char) => `${char}${char}`)
      .join('');
    return `#${expanded.toLowerCase()}`;
  }

  if (cleaned.length < 6) {
    const lastChar = cleaned[cleaned.length - 1] || '0';
    const padded = cleaned.padEnd(6, lastChar);
    return `#${padded.toLowerCase()}`;
  }

  return `#${cleaned.slice(0, 6).toLowerCase()}`;
};

export const getVariantColorKey = (variant = {}) => {
  const normalizedCode = normalizeColorCode(
    variant.colorCode ||
      variant.color?.code ||
      variant.color_code ||
      ''
  );
  if (normalizedCode) {
    return normalizedCode;
  }

  const name =
    (variant.colorName ||
      variant.color?.name ||
      variant.color ||
      '')
      .toString()
      .trim()
      .toLowerCase();
  if (name) {
    return name;
  }

  return (
    variant.colorId ||
    variant.color?.colorId ||
    variant.color?.id ||
    variant.id ||
    variant.variantId ||
    ''
  );
};

export const getReadableTextColor = (color = '') => {
  const hex = String(color).trim();
  if (!hex) return '#fff';
  let normalized = hex.replace('#', '').toLowerCase();
  if (normalized.length === 3) {
    normalized = normalized
      .split('')
      .map((char) => char + char)
      .join('');
  }
  if (!/^[0-9a-f]{6}$/.test(normalized)) {
    return '#fff';
  }
  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? '#1a1a1a' : '#ffffff';
};
